import { externalProducts } from '../constants/constants';

import { IncomeSource } from './createCustomer';
import { Product } from './enums';

export function isProduct(value: string): value is Product {
  return Object.values<string>(Product).includes(value);
}

export function isIncomeSource(value: string): value is IncomeSource {
  return Object.values<string>(IncomeSource).includes(value);
}

export function isExternalOnboardingProduct(product: Product) {
  return externalProducts.includes(product);
}

export function isFramMulti(product: Product) {
  return [Product.FRAM].includes(product);
}
